import { ROUTES } from "../../../api/api.routes";
import useCustomQuery, { QueryOpts } from "../../../hooks/useQuery";
import { useSearchUrl } from "../../../hooks/useSearch";
import { Doc } from "../../../types/db/collections";
import { GetLinkResponse } from "../../../types/db/schema/links/link.schema";

export const useLinks = (o?: QueryOpts) => {

  const { urlWithFilter } = useSearchUrl();

  const { data, isRefetching, isLoading, mutate } = useCustomQuery<Doc<GetLinkResponse>[]>(urlWithFilter(ROUTES.Links.All), o);

  return {
    links: data,
    isLoading,
    isRefetching,
    mutate
  }
}